import { OpenAPIApiClient } from '@fourthwall/services/dist/OpenAPIApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteOpenAPIConfigurationMutation = createMutationHook(
  OpenAPIApiClient.removeConfiguration,
  {
    mutationKey: ['deleteOpenAPIConfiguration'],
  },
)
